module.exports = __webpack_public_path__ + "cdb2c9d3b45897f7fcd6936521ba84e8.jpg";